import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Button, NoticeBox, Radio } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import type { ContractImporterContextProps } from 'modules/employees/components/ContractImporter/contractsImporterContext'
import {
  FormActions,
  ImportModeForm,
} from 'modules/employees/pages/ImportContractsPage/components/ImportModeForm'

interface Props {
  importer: ContractImporterContextProps
  onClose: () => void
}

const ImportModeSelect = ({ onClose, importer }: Props) => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const { company, access } = useCurrentSession()
  const form = React.useRef(
    new ImportModeForm({
      mode: FormActions.export_only_reference,
    })
  ).current
  const actionField = React.useRef(form.get('mode')).current

  useEffect(() => {
    track(trackingEvents.importContracts.startOldContractsImporter, {
      companyId: company.id,
      acessId: access.id,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onCloseModal = () => {
    importer.setMode('')
    onClose()
  }

  const onSubmit = () => {
    importer.setMode(actionField.value)
    navigate(navigation.employees.list.importContracts.fullPath())
  }

  return (
    <Modal
      title={i18n.t('import_contract.mode_selector.title')}
      description={i18n.t('import_contract.mode_selector.description')}
      illustration="table-file"
      onSubmit={onSubmit}
      onClose={onCloseModal}
      footer={
        <>
          <Button onClick={onCloseModal} type="secondary">
            {i18n.t('common.cancel')}
          </Button>
          <Button submit>{i18n.t('common.continue')}</Button>
        </>
      }
    >
      <Radio.Wrap>
        <Radio
          name={i18n.t('import_contract.mode_selector.import_current.name')}
          value={actionField.value}
          onChange={(value) => actionField.set(value)}
          description={i18n.t('import_contract.mode_selector.import_current.description')}
          option={{
            label: i18n.t('import_contract.mode_selector.import_current.name'),
            value: FormActions.export_only_reference,
          }}
        ></Radio>
      </Radio.Wrap>
      <Radio.Wrap>
        <Radio
          name={i18n.t('import_contract.mode_selector.import_all.name')}
          value={actionField.value}
          onChange={(value) => actionField.set(value)}
          description={i18n.t('import_contract.mode_selector.import_all.description')}
          option={{
            label: i18n.t('import_contract.mode_selector.import_all.name'),
            value: FormActions.export_all,
          }}
        />
      </Radio.Wrap>
      <NoticeBox
        paddingY="s24"
        color="viridian100"
        message={i18n.t('import_contract.mode_selector.info')}
      />
    </Modal>
  )
}

export default observer(ImportModeSelect)
